<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.processName']">
              <a-select v-model="queryParam.model_guid" allowClear >
                <a-select-option v-for="(process,index) in allProcess" :key="index" :value="process.processModelGuid" >
                  {{ process.processModelName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.businessFormNo']">
              <a-input  v-model="queryParam.business_form_no"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="10" :lg="11" :md="12" :sm="24">
            <a-form-item :label="language['eletronicSigned.queryDate']">
              <j-date :placeholder="language['common.chooseStartDate']" :showTime="false" :defaultValue="moment(queryParam.beginDate, 'YYYY-MM-DD')" dateFormat="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.beginDate"></j-date>
              <span class="query-group-split-cust"></span>
              <j-date :placeholder="language['common.chooseEndDate']" :showTime="false" :defaultValue="moment(queryParam.endDate, 'YYYY-MM-DD')" dateFormat="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.endDate"></j-date>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="search_reset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <!--<a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>{{language['common.choosed']}}&nbsp;<a style="font-weight: 600">{{
        selectedRowKeys.length }}</a>{{language['common.item']}}&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>-->

      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
        :scroll="{x:2000}">

        <template slot="processChartLot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-icon type="cluster" @click="openChart(record.process_guid)" style="color:#33A1FF"/>
            <j-modal
              switchFullscreen
              :mask="false"
              :width="1000"
              :title="language['eletronicSigned.processChart']"
              :visible="visible"
              :confirm-loading="confirmLoading"
              :ok-button-props="{ props: { disabled: true } }"
              @cancel="handleCancel"
              :ok-disabled="true"
              :cancelText="language['common.closeButton']">
              <img style="width: 100%;" :src="imgChartSrc"><!--'be00c9ad-45e8-a5c4-9c83-1523494a8a70'-->
            </j-modal>
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
          <!--<span v-if="record.process_status == 'Rejected' || record.process_status == 'Withdrawn'">
            <a-divider type="vertical"/>
            <a-popconfirm title="确定删除吗?" @confirm="() => handle_delete(record)">
              <a>删除</a>
            </a-popconfirm>
          </span>-->
          <span v-if="(record.process_status == 'Rejected' || record.process_status == 'Withdrawn')
          &&(record.app_Code!=='AuditWorkflow')">
            <a-divider type="vertical"/>
            <a @click="handle_cancel(record)">{{language['eletronicSigned.termination']}}</a>
          </span>
          <span v-if="(record.process_status == 'Started'
                      || record.process_status == 'Restarted'
                      || record.process_status == 'InProcess')
                      &&(record.app_Code!=='AuditWorkflow')
                      ">
            <a-divider type="vertical"/>
            <a @click="handle_withdraw(record)">{{language['eletronicSigned.withdraw']}}</a>
          </span>
        </span>

        <span slot="processStatus" slot-scope="text, record">
           <div style="color: red;" v-if="record.process_status === 'Rejected'||record.process_status === 'ReturnTo'">
             {{ text === 'Cancelled' ? language['eletronicSigned.termination'] : ((langCode === "zh_CN" || langCode === "zh_TW")?record.process_status_local_lang:record.process_status) }}
           </div>
          <div  v-else>{{ text === 'Cancelled' ? language['eletronicSigned.termination'] : ((langCode === "zh_CN" || langCode === "zh_TW")?record.process_status_local_lang:record.process_status) }}</div>
        </span>
        <span slot="task_status" slot-scope="text, record">
          {{ text === 'Cancelled' ? language['eletronicSigned.termination'] : ((langCode === "zh_CN" || langCode === "zh_TW")?record.task_status_local_lang:record.task_status) }}
        </span>
        <span slot="business_form_no" slot-scope="text, record">
          <div style="color: red;font-weight: 500;" v-if="record.process_status === 'Rejected'||record.process_status === 'ReturnTo'">{{text}}</div>
          <div  v-else>{{text}}</div>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <my-apply-modal ref="modalForm" @ok="modalFormOk"></my-apply-modal>
    <my-todo-comments-modal ref="myTodoCommentsModal"  @reSeach="searchQuery"></my-todo-comments-modal>

  </a-card>
</template>

<script>
  import MyApplyModal from './modules/MyApplyModal'
  import {putAction, getFileAccessHttpUrl,getAction} from '@/api/manage';
  import MyTodoCommentsModal from './modules/MyTodoCommentsModal'
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import JSuperQuery from '@/components/jeecg/JSuperQuery'
  import moment from "moment";
  import {withdraw} from "./auditJS/withdraw"
  import {cancel} from "./auditJS/cancel"
  import { ACCESS_TOKEN,USER_LANGUAGE } from "@/store/mutation-types"

  export default {
    name: "MyApplyList",
    mixins: [JeecgListMixin],
    components: {
      MyApplyModal,
      JInput,
      JSuperQuery,
      MyTodoCommentsModal,
    },
    data() {
      return {
        langCode:window.sessionStorage.getItem(USER_LANGUAGE),
        allProcess:[],
        imgChartSrc:"",
        processChartPrefix: "",
        processChartSuffix: "",
        processGuid: "",
        visible: false,
        confirmLoading: false,
        description: '这是我的申请页面',
        queryParam: {
          model_guid:"",
          businessFormNo:"",
          application_code:this.$store.getters.applicationCode,
          userCode: this.$store.getters.userInfo.userType==='employee'?this.$store.getters.userInfo.workNo:this.$store.getters.userInfo.username,
          taskListType: "AllMyRequest",
          beginDate: this.getBeginDate(),
          endDate: this.getEndDate(),
        },
        recycleBinVisible: false,
        tt: this,
        url: {
          list: "/sys/wfapi/getTaskList",
          delete: "/sys/wfapi/deleteProcess",
          withdrawUrl: "/sys/wfapi/pageToRunProcess",
        },
        /* 分页参数 */
        ipagination:{
            current: 1,
            pageSize: 10,
            pageSizeOptions: ['10', '20', '30'],
            showTotal: (total, range) => {
              return range[0] + "-" + range[1] +" "+ this.$store.getters.language['common.total']+" " + total +" "+ this.$store.getters.language['common.strip']
            },
            showQuickJumper: true,
            showSizeChanger: true,
            total: 0
        },
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },

      columns() {
        if (this.language) {
          return [
            {
              title: this.language['eletronicSigned.processName'],
              align: "center",
              dataIndex: 'process_name_local_lang',
              width: 200,
              sorter: true,
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
              customRender: function (text, r, index) {
                if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
                  return r.process_name_local_lang;
                }else{
                  return r.process_name_en;
                }
              }
            },
            {
              title: this.language['eletronicSigned.processStatus'],
              align: "center",
              width: 180,
              dataIndex: 'process_status',
              // customRender: function (text, r, index) {
              //   if (text === 'Cancelled') {
              //     // return this.tt.language['eletronicSigned.termination']
              //     // return this.termination;
              //     // return '终止'
              //     // return this.getLanguage('eletronicSigned.termination')
              //     return this.language['eletronicSigned.processName'];
              //     // return this.language('eletronicSigned.termination');
              //   } else {
              //     return r.process_status_local_lang;
              //   }
              // }
              scopedSlots: {customRender: 'processStatus'},
            },
            {
              title: this.language['eletronicSigned.businessFormNo'],
              align: "center",
              width: 200,
              dataIndex: 'business_form_no',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
              // scopedSlots: {customRender: 'business_form_no'},
            },
            {
              title: this.language['eletronicSigned.taskText'],
              align: "center",
              width: 150,
              dataIndex: 'task_text_local_lang',
              customRender: function (text, r, index) {
                if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
                  return r.task_text_local_lang;
                }else{
                  return r.task_text_en;
                }
              },
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['eletronicSigned.taskStatus'],
              align: "center",
              width: 150,
              dataIndex: 'task_status',
              scopedSlots: {customRender: 'task_status'},
              /*customRender: function (text, r, index) {
                if (text === 'Cancelled') {
                  return this.language['eletronicSigned.termination']
                } else {
                  return r.task_status_local_lang;
                }
              }*/
            },
            {
              title: this.language['eletronicSigned.createUserName'],
              align: "center",
              width: 150,
              dataIndex: 'create_user_name'
            },
            {
              title: this.language['eletronicSigned.startTime'],
              align: "center",
              width: 150,
              dataIndex: 'create_time'
            },
            {
              title: this.language['eletronicSigned.processChart'],
              align: "center",
              width: 100,
              dataIndex: 'process_guid',
              scopedSlots: {customRender: "processChartLot"}
            },
            /*{
              title: this.language['eletronicSigned.urgentDegree'],
              align: "center",
              width: 150,
              dataIndex: 'urgent_degree'
            },*/
            {
              title: this.language['eletronicSigned.approveResult'],
              align: "center",
              width: 160,
              dataIndex: 'approveResult',
              customRender: function (text, r, index) {
                if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
                  return r.approveResult;
                }else{
                  return r.approveResult_en;
                }
              },
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['eletronicSigned.approveName'],
              align: "center",
              width: 160,
              dataIndex: 'approveName',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['eletronicSigned.approveDate'],
              align: "center",
              dataIndex: 'approveDate'
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              scopedSlots: {customRender: 'action'},
              align: "center",
              width: 170,
              fixed: "right"
            }

          ]
        }
      }



    },
    created() {
      this.initAllprocess()
      getAction("/sys/wfapi/getProcessChart",{}).then(res=>{
        if (res.success) {
          this.processChartPrefix=res.result.prefix;
          this.processChartSuffix = res.result.suffix;
        }
      })
    },
    methods: {
      //查询对应的流程model
      getMode(record){
        if(record.model_guid){


        }
      },
      handle_cancel(record){
        getAction("/sys/processSigned/pfBpmModel/queryBymodelGuId?modelGuId="+record.model_guid,{}).then(res=>{
          if (res.success) {
            cancel(res.result.applicationCode,this,record)
          }
        })
        /*let map = {}
        map.pfBpmProcessId = record.process_guid;
        map.workNo = this.$store.getters.userInfo.workNo;
        map.approveAction = "Cancel";
        map.taskCode = record.task_code;
        this.title = "取消";
        this.$refs.myTodoCommentsModal.edit(map);*/
      },
      handle_withdraw(record){
        getAction("/sys/processSigned/pfBpmModel/queryBymodelGuId?modelGuId="+record.model_guid,{}).then(res=>{
          if (res.success) {
            withdraw(res.result.applicationCode,this,record)
          }
        })
        /*let map = {}
        map.pfBpmProcessId = record.process_guid;
        map.workNo = this.$store.getters.userInfo.workNo;
        map.approveAction = "Withdraw";
        map.taskCode = record.task_code;
        this.title = "撤回";
        this.$refs.myTodoCommentsModal.edit(map);*/
      },
      handle_delete(record){
        let param = {
          formNo: record.business_form_no,
          applicationCode: record.process_guid,
          process_guid: record.process_guid,
        }
        getAction(this.url.delete, param).then((res) => {
          if (res.success) {
            this.$message.success(this.language['common.deleteSuccess'])
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      moment,
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar)
      },
      openChart(process_guid) {
        this.visible = true;
        this.imgChartSrc = this.processChartPrefix + process_guid + this.processChartSuffix;
        if(this.imgChartSrc.split("?").length>1){
          this.imgChartSrc = this.imgChartSrc + "&timestamp="+ new Date().getTime();
        }else{
          this.imgChartSrc = this.imgChartSrc + "?timestamp="+ new Date().getTime();
        }
      },
      handleCancel(e) {
        this.visible = false;
      },
      search_reset() {
        this.queryParam = {
          model_guid:"",
          businessFormNo:"",
          application_code:this.$store.getters.applicationCode,
          userCode: this.$store.getters.userInfo.userType==='employee'?this.$store.getters.userInfo.workNo:this.$store.getters.userInfo.username,
          taskListType: "AllMyRequest",
          beginDate: this.getBeginDate(),
          endDate: this.getEndDate(),
        },
        this.loadData(1);
      },
      initAllprocess(){
        getAction("/sys/processSigned/pfBpmModel/listWithOutPage", {applicationCode:this.$store.getters.applicationCode}).then((res) => {
          if (res.success) {
            let list = [];
            res.result.forEach(item=>{
              let map = {};
              map.processModelGuid = item.modelGuid;
              if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
                map.processModelName = item.modelNameLocalLang;
              }else{
                map.processModelName = item.modelNameEn;
              }
              list.push(map);
            })
            this.allProcess = list;
          } else {
          }
        })
      },

      getBeginDate(){
        let date= new Date();
        date.setMonth(date.getMonth() - 1)
        let day = date.getDate()>9?date.getDate():'0'+date.getDate();
        // let month = date.getMonth()>9?date.getMonth():(date.getMonth()!==0?'0'+date.getMonth():0);
        let month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1);
        let year = date.getFullYear();
        /*if(month===0){
          year = year-1;
          month = 12;
        }*/
        return year+'-'+month+'-'+day;
      },
      getEndDate(){
        let date= new Date();
        let day = date.getDate()>9?date.getDate():'0'+date.getDate();
        let year = date.getFullYear()
        let month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1);
        return year+'-'+month+'-'+day+' 23:59:59';
      },

    }

  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>